import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var UnitService = /** @class */ (function () {
    function UnitService() {
        this.subject = new Subject();
    }
    UnitService.prototype.put = function (unit) {
        this.subject.next(unit);
    };
    UnitService.prototype.get = function () {
        return this.subject.asObservable();
    };
    UnitService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    UnitService.ctorParameters = function () { return []; };
    return UnitService;
}());
export { UnitService };
//# sourceMappingURL=unit.service.js.map